import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var submitPollRes;
export const submitPollTodo = createAsyncThunk('submitPoll', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/submit_poll',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "poll_id": val.poll_id,
                "submit_option": val.option,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return submitPollRes = res.data
    } catch (error) {
        return submitPollRes = error.response.data
    }
})